/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Accessibility_DescriptionInputs */

const he_seo_accessibility_description = /** @type {(inputs: Seo_Accessibility_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricedrop מחויב לספק חווית שימוש נגישה לכלל המשתמשים.`)
};

const en_seo_accessibility_description = /** @type {(inputs: Seo_Accessibility_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricedrop is committed to providing an accessible experience for all users.`)
};

/**
* | output |
* | --- |
* | "Pricedrop is committed to providing an accessible experience for all users." |
*
* @param {Seo_Accessibility_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_accessibility_description = /** @type {((inputs?: Seo_Accessibility_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Accessibility_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_accessibility_description(inputs)
	return en_seo_accessibility_description(inputs)
});